export default "__VITE_ASSET__J0yMmRkM__"